<template>
  <div
    class="*:odd:text-gray-300[&_p]:even:font-medium grid h-fit shrink-0 grid-cols-[auto_auto] items-center gap-x-4 gap-y-3 [&>p:empty]:even:before:content-['-']"
  >
    <!-- Name -->
    <p>Naam</p>
    <p>{{ meteringPoint.displayName }}</p>

    <!-- EAN -->
    <p>EAN</p>
    <p>{{ mpProps.ean }}</p>

    <!-- Location -->
    <p>Locatie</p>
    <p v-if="!viewStore.anonymize && mpProps.address">
      {{ mpProps.address.address }},
      {{ mpProps.address.city }}
    </p>
    <p v-else>-</p>

    <!-- Grid connection -->
    <p>Maximaal vermogen afname net</p>
    <p>{{ formatKW(mpProps.grid_connection?.max_power_in) }}</p>
    <p>Maximaal vermogen teruglevering net</p>
    <p>{{ formatKW(mpProps.grid_connection?.max_power_out) }}</p>
  </div>
</template>

<script setup>
import { computed } from "vue"
import { formatKW } from "@/helpers/formatter.js"
import useViewStore from "@/stores/viewStore.js"

const props = defineProps({
  meteringPoint: {
    type: Object,
    default: null,
  },
})

const viewStore = useViewStore()

const mpProps = computed(() => props.meteringPoint?.properties || {})
</script>
